module.exports = __webpack_public_path__ + "static/media/samarth.4c5e8c6d.jpeg";